import {Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {VuexObjectMixin} from '../../../Mixins';
import Modal from '../../Modal/Modal.vue';
import PublicTransportItem from '../PublicTransportItem/PublicTransportItem.vue';
import {mapGetters} from 'vuex';
import {AdditionalOrderItemConfiguration} from '../../../Models/AdditionalOrderItemConfiguration';
import {PublicTransportConfig} from '../../../Models/PublicTransportConfig';
import {Product} from '../../../Models';
import {UUID4Utility} from '../../../Utilities';

@Component({
  components: {
    Modal,
    PublicTransportItem,
  },
  computed: {
    ...mapGetters({
      currentBuyerData: 'getBuyerData',
    }),
  },
})
export default class RegistrationPublicTransportModal extends VuexObjectMixin {
  @Prop({type: String, required: true}) modalTriggerText: string | undefined;
  @Prop({type: Function, required: true}) submitCb: any;
  @Prop({type: Object, required: true}) product: Product | undefined;
  @Prop({
    type: Number, required: false, default: () => {
      return null;
    },
  }) slotId: number | null | string | undefined;

  additionalOrderItemConfig: AdditionalOrderItemConfiguration | null = null;

  mounted() {
    this.additionalOrderItemConfig = new AdditionalOrderItemConfiguration({
      id: UUID4Utility.uuid4(),
      orderItemId: UUID4Utility.uuid4(),
      parentOrderItemId: null,
      personalUse: true,
      publicTransportConfig: new PublicTransportConfig({
        id: UUID4Utility.uuid4(),
        passengerName: null,
        passengerSurname: null,
        usePubTrans: false,
        selectedDate: null,
        productId: this.product?.id || null,
        slotId: this.slotId || null,
      }),
      productId: this.product?.id || null,
      slotId: this.slotId || null,
      orderItem: null,
    });
  }

  updateAdditionalOrderItemConfig() {
    if (this.submitCb && this.additionalOrderItemConfig) {
      this.submitCb([this.additionalOrderItemConfig.publicTransportConfig]);
    }
  }
}
